module.exports = __webpack_public_path__ + "aa.no2.bb5fe6c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/aa.no2.jpg
// module id = vsRW
// module chunks = 0